<template>
  <div class="AppUpload">
    <el-upload
      action="#"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="handleImgSelectChange"
    >
      <i
        v-if="!src && !materialUrl"
        class="el-icon-plus avatar-uploader-icon"
      ></i>
      <div>
        <el-button
          v-if="src || materialUrl"
          class="btn"
          size="mini"
          plain
          type="primary"
          slot="trigger"
          >重新上传
        </el-button>
        <el-button
          v-else
          class="btn"
          size="mini"
          plain
          type="primary"
          slot="trigger"
          >上传图片
        </el-button>
        <MaterialPicker
            materialType="image"
            @onConfirmPickMaterial="onConfirmPickMaterial"
        ></MaterialPicker>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MaterialPicker from "@/pages/MaterialCenter/components/MaterialPicker.vue";

export default {
  name: "AppUpload",
  components: {MaterialPicker},
  props: {
    materialUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      src: "",
    };
  },
  computed: {
    ...mapState("tenant", ["ossUploadObj"]),
  },
  methods: {
    ...mapActions("tenant", ["generalUploadUrl"]),
    onConfirmPickMaterial(item) {
      this.$emit("onConfirmPickMaterial", item);
    },
    handleImgSelectChange(file) {
      this.$emit("beforeUpload", file, (shouldUpload) => {
        if (shouldUpload) {
          // 执行下面的事件
          this.doUpload(file);
        }
      });
    },
    async doUpload(file) {
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
        .then((res) => {
          console.log(res);
          this.src = URL.createObjectURL(file.raw);
          this.$emit("afterUpload", this.src, this.ossUploadObj.filename);
        })
        .catch((e) => {
          console.log(e);
          this.src = "";
          this.$message.error("上传失败，请重新上传！");
          this.$emit("afterUpload", this.src, "");
        });
      this.$axios.defaults.withCredentials = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.AppUpload {
  .avatar-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    border: 1px solid #dcdfe6;
    border-radius: 50%;
  }
}
</style>
